<template>
  <div v-if="distribution && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <OnePiecePrint :formater="formater" :data="distribution" />
  </div>
</template>
<script>
import StockOuts from "@/api/stock_outs";
import PrintTemplates from "@/api/print_templates";
import OnePiecePrint from "@/components/plugins/print/OnePiecePrint";
import makeData from "../distributions/makeData";

export default {
  components: {
    OnePiecePrint,
  },

  data: () => ({
    formater: null,
    distribution: null,
  }),

  mounted() {
    PrintTemplates.fetchOne("distribution").then(
      function (response) {
        if (response.data.status.isOK()) {
          var formater = response.data.print_template.template;
          // formater.page_header_left = [];
          // formater.headers = [];
          // formater.title = null;
          // formater.settings.table_head_repetitive = false;
          // formater.settings.hide_page_counter = true;
          // formater.expand_columns = formater.expand_columns_bak; //.splice(0, 1);
          // formater.group_column = formater.group_column_bak;
          // formater.group_sum_columns = formater.group_sum_columns_bak; //.splice(0, 1);
          // formater.columns = formater.columns.splice(0, 7);
          // formater.sum_columns = [];
          this.formater = formater;
          //获取单据详情
          StockOuts.distributionPrint(this.$route.params.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                var stock_out = response.data.stock_out;
                var order_address = response.data.order_address;
                var distribution = makeData.processDetails(
                  stock_out.distribution
                );
                stock_out.order.shop = this.$printUtils.addCitiesName(
                  stock_out.order.shop
                );
                this.distribution = {
                  order: stock_out.order,
                  distribution: Object.assign({}, stock_out, distribution),
                  order_address: order_address,
                  print_date: new Date().toISOString().substr(0, 10),
                };
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  },
};
</script>